module.exports = __webpack_public_path__ + "img/hk.a554e05d.png";